module.exports = __webpack_public_path__ + "static/img/html.7589a0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/html.png
// module id = /XRT
// module chunks = 0